module.exports = __webpack_public_path__ + "assets/img/translation-case-3.3293b87b.png";